import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "currimundi",
  name: "Currimundi",
  title: "Currimundi conveyancing, wills and elder law",
  metaTitle: `Currimundi Conveyancing & Wills Lawyers | ${FIRM.name}`,
  description: `Fixed-fee Currimundi conveyancing — sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. Wills, enduring powers of attorney and estates. Call ${FIRM.phone}.`,
  lead: "Currimundi is a family and retiree suburb with a wide mix of housing — lakeside homes, duplexes, over-50s living and standard freehold blocks. Each has a different set of contract questions.",
  paragraphs: [
    "We act for Currimundi buyers, sellers and downsizers from our Golden Beach office, ten minutes up the road. A good number of our Currimundi matters are people moving out of a large family home into something smaller, which usually means a sale and a purchase running side by side.",
    "Those back-to-back settlements need timing. We coordinate the sale and purchase so you are not left funding two properties or homeless for a week, and we tell you early if the dates do not work.",
    "Downsizing is also the moment most people should refresh their will and enduring power of attorney. We can do both while the conveyance is running.",
  ],
  localNotes: [
    {
      t: "Simultaneous sale and purchase",
      d: "Matching settlement dates, bridging risk and the order funds move on the day. Getting this wrong is the most expensive mistake in a downsizing move.",
    },
    {
      t: "Over-50s and lifestyle communities",
      d: "Site agreements and retirement village contracts are not ordinary conveyances. Exit fees, deferred management fees and resale terms need reading before you sign.",
    },
    {
      t: "Lake and flood overlays",
      d: "Properties near Currimundi Lake can sit in flood or storm tide overlays affecting insurance and future building work. The planning search tells us what applies.",
    },
    {
      t: "Duplexes and small schemes",
      d: "Duplex pairs are usually community title with shared insurance and maintenance. Confirm the scheme's records and any existing dispute before you commit.",
    },
  ],
  suburbs: ["Wurtulla", "Aroona", "Little Mountain", "Dicky Beach", "Caloundra", "Battery Hill"],
  faqs: [
    {
      q: "Can you handle my sale and purchase at the same time?",
      a: "Yes, and it is one of the most common things we do. We align the settlement dates where possible, flag any funding gap early, and manage both settlements on the day so the money flows in the right order.",
    },
    {
      q: "Is a retirement village contract the same as buying a house?",
      a: "No. In most Queensland villages you buy a right to reside rather than freehold title, and the exit or deferred management fee can be a substantial share of the value. Those contracts must be reviewed on their own terms.",
    },
    {
      q: "Should I update my will when I downsize?",
      a: "Almost always. A will that gifts a specific property no longer owned can fail, and the sale changes the shape of your estate. We usually prepare the new will while the conveyance is on foot.",
    },
  ],
};
